<template>
  <div class="checkout-form-group__fields checkout-form-group__fields--corporate">
    <div class="row checkout-form-group__row-fields">

      <div class="col-lg-6 col-xl-4">
        <div
          class="form-group checkout-form-group__field-group">
          <div class="form-group__label">ИНН*</div>
          <div class="form-group__field">
            <input
              v-model="order.inn"
              v-bind:class="{ 'is-invalid': errors.inn }"
              type="text" class="form-control">
              <p class="invalid-feedback" v-if="errors.inn">
                {{ errors.inn.join(', ') }}</p>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-xl-4">
        <div
          class="form-group checkout-form-group__field-group">
          <div class="form-group__label">Название компании*</div>
          <div class="form-group__field">
            <input
              v-model="order.company_name"
              v-bind:class="{ 'is-invalid': errors.company_name }"
              type="text" class="form-control">
              <p class="invalid-feedback" v-if="errors.company_name">
                {{ errors.company_name.join(', ') }}</p>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-xl-4">
        <div
          class="form-group checkout-form-group__field-group">
          <div class="form-group__label">Юридический адрес</div>
          <div class="form-group__field">
            <input
              v-model="order.company_address"
              v-bind:class="{ 'is-invalid': errors.company_address }"
              type="text" class="form-control">
              <p class="invalid-feedback" v-if="errors.company_address">
                {{ errors.company_address.join(', ') }}</p>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-xl-4">
        <div
          class="form-group checkout-form-group__field-group">
          <div class="form-group__label">КПП</div>
          <div class="form-group__field">
            <input
              v-model="order.company_kpp"
              v-bind:class="{ 'is-invalid': errors.company_kpp }"
              type="text" class="form-control">
              <p class="invalid-feedback" v-if="errors.company_kpp">
                {{ errors.company_kpp.join(', ') }}</p>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-xl-4">
        <div
          class="form-group checkout-form-group__field-group">
          <div class="form-group__label">Имя*</div>
          <div class="form-group__field">
            <input
              v-model="order.first_name"
              v-bind:class="{ 'is-invalid': errors.first_name }"
              type="text" class="form-control">
              <p class="invalid-feedback" v-if="errors.first_name">
                {{ errors.first_name.join(', ') }}</p>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-xl-4">
        <div class="form-group checkout-form-group__field-group">
          <div class="form-group__label">Отчество</div>
          <div class="form-group__field">
            <input
              v-model="order.third_name"
              v-bind:class="{ 'is-invalid': errors.third_name }"
              type="text" class="form-control">
              <p class="invalid-feedback" v-if="errors.third_name">
                {{ errors.third_name.join(', ') }}</p>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-xl-4">
        <div class="form-group checkout-form-group__field-group">
          <div class="form-group__label">Фамилия</div>
          <div class="form-group__field">
            <input
              v-model="order.second_name"
              v-bind:class="{ 'is-invalid': errors.second_name }"
              type="text" class="form-control">
              <p class="invalid-feedback" v-if="errors.second_name">
                {{ errors.second_name.join(', ') }}</p>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-xl-4">
        <div class="form-group checkout-form-group__field-group">
          <div class="form-group__label">Телефон*</div>
          <div class="form-group__field">
            <input
              v-model="order.phone"
              v-bind:class="{ 'is-invalid': errors.phone }"
              v-mask="'+7(###)###-##-##'" placeholder="+7(xxx)xxx-xx-xx"
              type="text" class="form-control">
              <p class="invalid-feedback" v-if="errors.phone">
                {{ errors.phone.join(', ') }}</p>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-xl-4">
        <div class="form-group checkout-form-group__field-group">
          <div class="form-group__label">Email*</div>
          <div class="form-group__field">
            <input
              v-model="order.email"
              v-bind:class="{ 'is-invalid': errors.email }"
              type="email" class="form-control">
              <p class="invalid-feedback" v-if="errors.email">
                {{ errors.email.join(', ') }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group checkout-form-group__field-group">
      <div class="form-group__label">Комментарий</div>
      <div class="form-group__field">
        <textarea
          v-model="order.comment"
          v-bind:class="{ 'is-invalid': errors.comment }"
          class="form-control"></textarea>
          <p class="invalid-feedback" v-if="errors.comment">
            {{ errors.comment.join(', ') }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {

  name: 'CheckoutCorporateForm',
  
  props: {
    order: {
      type: Object,
      default: null
    },
    errors: {
      type: Object,
      default: {}
    }
  },

  components: {

  },

  data() {
    return {

    }
  },

  mounted() {

  },

  methods: {

  },

}
</script>


<style lang="scss"></style>
